import axios from 'axios';

const LocationService = {
  getAll() {
    return axios.get('location').catch((error) => {
      throw new Error(`LocationService.getAll ${error}`);
    });
  },
  get(id) {
    return axios.get(`location/${id}`).catch((error) => {
      throw new Error(`LocationService.get ${error}`);
    });
  },
};

export default LocationService;
